import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { SearchCustomerParam } from 'src/app/Models/searchCustomer';
import { TransactionService } from '../../../Services/transaction.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from 'src/app/Services/notification.service';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from 'src/app/Pipes/date-format.pipes';
import { SpraSearch, SpraStatusReport } from 'src/app/Models/ops';

@Component({
  selector: 'app-spra-salesadminapprev-list',
  templateUrl: './spra-salesadminapprev-list.component.html',
  styleUrls: ['./spra-salesadminapprev-list.component.css'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
   ],
})
export class SpraSalesadminapprevListComponent implements OnInit {

  EmployeeId:number=0;
  private utility: Utility  
  public ValidationListAdminsalesHeader: String[] = ["requestNo","saleCode","partyName", "productCategory", "saleType", "lastValidatedBy","validatedate","isRental","status"];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public IsCeha:boolean;
  public todays:Date;
  public fromdays:Date ;
 public FromDate:any;
 public ToDate:any;
 public customerName:string;
 public SpraNumber:string;

  constructor(private _TransactionService: TransactionService
    , private intl: MatPaginatorIntl
    , private changeDectector: ChangeDetectorRef
    , private router: Router
    , private route: ActivatedRoute
    , private cookieService: CookieService
    , private _NotificationService:NotificationService) {

      this.utility = new Utility(this.cookieService);
      this.sort = new MatSort();
      this.paginator = new MatPaginator(this.intl, this.changeDectector);
      this.IsCeha = false;
      this.customerName="";
      this.SpraNumber ="";
      this.todays = new Date();
      this.fromdays= new Date(this.todays);
      this.fromdays.setDate(this.fromdays.getDate()-30)
      this.FromDate={"year": this.fromdays.getFullYear(),"month": this.fromdays.getMonth()+1,"day": this.fromdays.getDate()};
      this.ToDate={"year": this.todays.getFullYear(),"month": this.todays.getMonth()+1,"day": this.todays.getDate()};
      this.route.params.subscribe( (params) =>{
        if(params.IsCeha != undefined && params.IsCeha ==1){
          this.IsCeha = true;
        }
      });
  
      let param: any = this.router.getCurrentNavigation()?.extras.state;
      if (param) {     
        if (param.Message){
          this._NotificationService.showSuccess(param.Message,"");
        }
         }
     }

  ngOnInit(): void {
        // this.EmployeeId=this.utility.user.employeeId;
    
  }
  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  public doFilter = (event: any) => {
    this.dataSource.filter = event.target.value.trim().toLocaleLowerCase();
  }
  onRequestClick(row :any) {
    let page:string = "spra-request"
    if(row.isRental){
      page = "spra-rental-request";
    }


    this.router.navigate([page], {
      state: {
        "SPRAId": row.id,
        "UpdateTag": "U",
        "IsSalesAdmin":true,
        "RefId": row.refId,
        "SaleCode": row.saleCode,
        "OfficeId": row.officeID  ,
        "SaleType": row.saleType,
        "CompanyId": row.companyID,
        "PartnerId": row.partnerId,
        "IsCeha":this.IsCeha, //Added by rahul yadav on 7/6/2021 in case of 
        "IsFromApprovedlist":true //Added by rahul yadav on 10/05/2022 in case of 

      }
    });

  }
  validation():boolean{
    let Valid:boolean=true;
   if(this.FromDate == undefined){
     this._NotificationService.showWarning("Please enter From Date ", "");
     Valid=false;
   }
   else if(this.ToDate == undefined){
     this._NotificationService.showWarning("Please enter To Date", "");
     Valid= false;
   }
    return Valid;
  }
  OnSubmit(){
    if(this.validation()){
      let spraSearch:SpraSearch;
      spraSearch=new SpraSearch();
      spraSearch.FromDate=this.utility.GetdatePickerDate(this.FromDate);
      spraSearch.ToDate=this.utility.GetdatePickerDate(this.ToDate);
      spraSearch.CustomerName=this.customerName;
      spraSearch.SPRANumber = this.SpraNumber;
      spraSearch.IsCeha = this.IsCeha;
      this._TransactionService.GetSpraApprovedReviewListForAdminSales(spraSearch).subscribe((d: any) => {
        //console.log(d)
        this.dataSource.data = d;
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
      }, (error) => {                              //Error callback
        this.utility.Error(error);
      });
    }
    
  }

}
